export const ROUTES = {
  TO_DASHBOARD: '/dashboard',
  TO_WIZARD: '/wizard',
  TO_HELP: '/help',
  TO_REGISTER: '/register',
  TO_LOGIN: '/login',
  TO_LOGOUT: '/logout',
  TO_PASSWORD_FORGOTTEN: '/password_forgotten',
  TO_IMPRESSUM: '/impressum',
  TO_DATENSCHUTZ: '/datenschutz',
  TO_REVIT_PLUGIN: '/revit',
  TO_REGISTER_VERIFICATION: '/register_verification/:token',
  TO_RECREATE_PASSWORD: '/recreate_password/:token',
  TO_ARCHIVE: '/projects/archive',
  TO_PROJECTS: '/projects',
  TO_DOCUMENTATIONS: '/documentations',
  TO_DOCUMENTATION:  (id) => (id !== undefined)? '/documentations/' + id : '/documentations/:productSystemId',
  TO_PROJECT:  (id) => (id !== undefined)? '/projects/' + id : '/projects/:projectId',
  TO_PROJECT_BASICS:  (id) => (id !== undefined)? '/projects/' + id + '/basics': '/projects/:projectId/basics',
  TO_PROJECT_CONTACT:  (id) => (id !== undefined)? '/projects/' + id + '/contact': '/projects/:projectId/contact',
  TO_PROJECT_CUSTOMER:  (id) => (id !== undefined)? '/projects/' + id + '/customer': '/projects/:projectId/customer',
  TO_PROJECT_HELP:  (id) => (id !== undefined)? '/projects/' + id + '/help': '/projects/:projectId/help',
  TO_ACCOUNT: '/account',
  TO_SETTINGS: '/account/settings',
  TO_CHANGE_PASSWORD: '/account/change_password',
  TO_PARTICIPATIONS: '/account/participations',
  TO_TERMS_OF_USE: '/nutzungsbedingungen',
  TO_ELIMINATE_ACCOUNT: '/account/loeschen',
  TO_MANAGE_ACCESS_TOKEN: '/account/access_token',
};



// WEBPACK FOOTER //
// ./src/routes.js